import { render, staticRenderFns } from "./depreciations.pug?vue&type=template&id=7e23b1f0&lang=pug&"
import script from "./depreciations.js?vue&type=script&lang=js&"
export * from "./depreciations.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e23b1f0')) {
      api.createRecord('7e23b1f0', component.options)
    } else {
      api.reload('7e23b1f0', component.options)
    }
    module.hot.accept("./depreciations.pug?vue&type=template&id=7e23b1f0&lang=pug&", function () {
      api.rerender('7e23b1f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adminLayout/views/depreciations/index.vue"
export default component.exports